import { useSelector, useDispatch } from 'react-redux'
import { userLoggedOut } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSendVerifyCode } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { withoutAuthRoutes } from 'configs/routes.config'
import { useLocation } from 'react-router-dom'

function useAuth() {
    const dispatch = useDispatch()
    const location = useLocation()

    const { token, signedIn } = useSelector((state) => state.auth.session)
    const userInfo = useSelector((state) => state.auth.user)

    const sendVerifyCode = async ({ phoneNumber }) => {
        try {
            const resp = await apiSendVerifyCode({
                login_from: 1,
                phone: phoneNumber,
                provide_method: 'login',
            })

            if (resp.status === 204) {
                return {
                    status: true,
                    message: '',
                }
            }

            return {
                status: 'failed',
                message: '系統發生錯誤',
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signIn = async ({ phoneNumber, verifyCode }) => {
        try {
            const resp = await apiSignIn({
                login_from: 1,
                phone: phoneNumber,
                code: verifyCode,
            })
            if (resp.data) {
                dispatch(onSignInSuccess(resp.data))
                // * dispatch 後導航行行為在 ProtectedRoute.js 中

                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(userLoggedOut())
        window.location.replace(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        try {
            await apiSignOut()
            handleSignOut()
        } catch (errors) {
            handleSignOut()
        }
    }

    // withoutAuthRoutes 裡面有 public 的路由，因此以 'public' 檢查
    const isWithoutAuthRoute = withoutAuthRoutes.some((route) =>
        location.pathname.includes('public')
    )

    // 說明：這裡是用來檢查使用者是否有登入，如果沒有登入，則導向登入頁面
    const authenticated = token && signedIn

    return {
        authenticated,
        isWithoutAuthRoute,
        sendVerifyCode,
        signIn,
        signOut,
        userInfo,
    }
}

export default useAuth
